import React, { useEffect } from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import WaitlistForm from '../components/WaitlistForm';
import waitlistService from '../firebase/waitlistService';

const WaitlistPage = () => {
  useEffect(() => {
    // Initialize beta stats if they don't exist
    const initStats = async () => {
      try {
        await waitlistService.initializeBetaStats();
      } catch (error) {
        console.error('Error initializing beta stats:', error);
      }
    };
    
    initStats();
  }, []);

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 4, 
            mb: 4, 
            borderRadius: 2,
            backgroundImage: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)',
            color: 'white'
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
            FixMatePro: Your Business WhatsApp, Working 24/7
          </Typography>
          
          <Typography variant="h5" gutterBottom>
            Never Miss a Job Again - Grow Your Business With 24/7 Automation
          </Typography>
          
          <Typography variant="body1" sx={{ mt: 2 }}>
            Your customers are already messaging you on WhatsApp. Now you can be there for them 24/7 without being chained to your phone. Stop missing customer inquiries and grow your business with automated responses and appointment scheduling.
          </Typography>
        </Paper>
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4, mb: 4 }}>
          <Paper sx={{ p: 3, flex: 1, borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              WhatsApp Integration Made Simple
            </Typography>
            <Typography variant="body1" paragraph>
              We set up a professional WhatsApp business number for your company.
            </Typography>
            <Typography variant="body1">
              Our AI responds to common questions and collects customer information.
            </Typography>
          </Paper>
          
          <Paper sx={{ p: 3, flex: 1, borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Perfect For Service Professionals
            </Typography>
            <Typography variant="body1" paragraph>
              Plumbers, Electricians, HVAC Technicians, Handymen and any service professional using WhatsApp for business.
            </Typography>
            <Typography variant="body1">
              Book jobs while you're on a service call, send quotes without interrupting your work.
            </Typography>
          </Paper>
          
          <Paper sx={{ p: 3, flex: 1, borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              You're In Control
            </Typography>
            <Typography variant="body1" paragraph>
              Just take messages when you're busy, send quotes and book jobs, or use full 24/7 automated assistant.
            </Typography>
            <Typography variant="body1">
              You decide when to automate and when to take over the conversation.
            </Typography>
          </Paper>
        </Box>
        
        <WaitlistForm />
      </Box>
    </Container>
  );
};

export default WaitlistPage;
